import { toast } from 'vue3-toastify'

export default {
  data() {
    return {
      isOffline: false,
      offlineToastId: null
    }
  },

  mounted() {
    window.addEventListener('offline', this.handleOffline)
    window.addEventListener('online', this.handleOnline)

    if (!navigator.onLine) this.handleOffline()
  },

  beforeUnmount() {
    window.removeEventListener('offline', this.handleOffline)
    window.removeEventListener('online', this.handleOnline)
  },

  methods: {
    handleOffline() {
      if (this.isOffline) return

      this.isOffline = true
      this.offlineToastId = toast.error(
        `${this.$t('gui.offlineheading')} ${this.$t('gui.offlinetext')}`,
        { autoClose: false, toastId: 'offline-toast' }
      )
    },

    handleOnline() {
      if (!this.isOffline) return

      this.isOffline = false
      if (this.offlineToastId !== null) {
        toast.remove(this.offlineToastId)
        this.offlineToastId = null
      }
      toast.info(`${this.$t('gui.onlineheading')} ${this.$t('gui.onlinetext')}`)
    }
  }
}
